import { __extends } from "tslib";
import { DescribeChannelModeratorRequest, DescribeChannelModeratorResponse } from "../models/models_0";
import { deserializeAws_restJson1DescribeChannelModeratorCommand, serializeAws_restJson1DescribeChannelModeratorCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
/**
 * <p>Returns the full details of a single ChannelModerator.</p>
 *          <note>
 *             <p>The <code>x-amz-chime-bearer</code> request header is mandatory. Use the
 *                <code>AppInstanceUserArn</code> of the user that makes the API call as the value in
 *             the header.</p>
 *          </note>
 * @example
 * Use a bare-bones client and the command you need to make an API call.
 * ```javascript
 * import { ChimeSDKMessagingClient, DescribeChannelModeratorCommand } from "@aws-sdk/client-chime-sdk-messaging"; // ES Modules import
 * // const { ChimeSDKMessagingClient, DescribeChannelModeratorCommand } = require("@aws-sdk/client-chime-sdk-messaging"); // CommonJS import
 * const client = new ChimeSDKMessagingClient(config);
 * const command = new DescribeChannelModeratorCommand(input);
 * const response = await client.send(command);
 * ```
 *
 * @see {@link DescribeChannelModeratorCommandInput} for command's `input` shape.
 * @see {@link DescribeChannelModeratorCommandOutput} for command's `response` shape.
 * @see {@link ChimeSDKMessagingClientResolvedConfig | config} for command's `input` shape.
 *
 */
var DescribeChannelModeratorCommand = /** @class */ (function (_super) {
    __extends(DescribeChannelModeratorCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeChannelModeratorCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DescribeChannelModeratorCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "ChimeSDKMessagingClient";
        var commandName = "DescribeChannelModeratorCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: DescribeChannelModeratorRequest.filterSensitiveLog,
            outputFilterSensitiveLog: DescribeChannelModeratorResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeChannelModeratorCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1DescribeChannelModeratorCommand(input, context);
    };
    DescribeChannelModeratorCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1DescribeChannelModeratorCommand(output, context);
    };
    return DescribeChannelModeratorCommand;
}($Command));
export { DescribeChannelModeratorCommand };
//# sourceMappingURL=DescribeChannelModeratorCommand.js.map